import { createContext } from "react";

export const AuDlConsentLayoutContext = createContext<{
  label?: string;
  subLabel?: string;
}>({});
